import axios from 'axios'
// ------------------------------------------------------
// import { Toast } from 'vant'
import router from "../router/index"
// ------------------------------------------------------

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_PROXY_TARGET + process.env.VUE_APP_API_BASE_URL,
  timeout: 20000 // 请求超时时间
  // responseType: 'blob'
})

// request interceptor请求拦截器
request.interceptors.request.use(config => {
  // console.log('进入请求拦截器request.interceptors')
  const token = localStorage.ACCESS_TOKEN
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
}, errorHandler)

// response interceptor响应拦截器
request.interceptors.response.use(response => {

  // 当证书单个下载时，将响应头部的文件名塞到data里返回到请求方法的res里
  if (response.headers.filename) {
    response.data['filename'] = response.headers.filename
  }
  return response.data
}, errorHandler)

// 异常拦截处理器
const errorHandler = error => {
  // console.log('进入异常拦截处理器errorHandler')
  if (error.response) {
  //   const data = error.response.data
    // 从 localstorage 获取 token
    // const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 401) {
      router.push('/')
    }
    if (error.response.status === 403) {
      router.replace({
        path: "/"
      })
    }
    // if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
    //     Toast.error({
    //     message: 'Unauthorized',
    //     description: 'Authorization verification failed'
    //   })
    //   if (token) {
    //     store.dispatch('Logout').then(() => {
    //       setTimeout(() => {
    //         window.location.reload()
    //       }, 1500)
    //     })
    //   }
    // }
  }
  return Promise.reject(error)
}

export default request

export {
  request as axios
}
